import React from "react"
import { PanelBarGLPure, InputHLPure } from "../../pures"

const ValidateFreelanceVarsView = (props) => {
    let { 
        varsOCR,
        handleChangeVars
    } = props

    return(
        <div className="validateFreelanceView-panel-vars">
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={'Variables'}
                className='validateFreelanceView'
            >
                {
                    varsOCR.map((variable, index) => {
                        return(
                            <div className="validateFreelanceView-vars-container">
                                <InputHLPure
                                    typeInput="text"
                                    labelInput={variable.id}
                                    valueInput={variable.value}
                                    handleChangeInput={(e) =>handleChangeVars(e, variable)}
                                    tooltipShow={false}
                                    informationIcon={false}
                                    inputActive={true}
                                />
                            </div>      
                        )
                    })
                }
            </PanelBarGLPure>
        </div>
    )
}

export { ValidateFreelanceVarsView as default }